// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AdaptiveTextarea_wrapper_eF10O","centerBackground":"AdaptiveTextarea_centerBackground_3uvpu","textarea":"AdaptiveTextarea_textarea_3Tjdr"};